import { gql } from '@apollo/client/core';

export const BGC_PRICING_QUERY = gql`
  query bgcPricing {
    bgcPricing {
      checkType
      listPrice
      memberPrice
    }
  }
`;

export default BGC_PRICING_QUERY;
